import { EventEmitter } from '@angular/core';
import { SupervisionError, Supervision, Site, SupervisionStatusEnum, SolarErr, Panel } from 'solar-bo';;
import { SolarService } from './solarservice.service';
import { AppInjector } from 'base-models';
import { NotifierService } from 'basecomponents';
import { NotificationType, AlertType } from 'base-models';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
//import { TimePerf } from 'projects/shtools/src/lib';
import { TimePerf } from 'shtools';


export class SolarLoaderBase {

    id_supervision: string
    supervision: Supervision;
    site: Site;
    issues: SupervisionError[] = [];//all issues
    site_panels_type: any[] = [];
    site_panels: any[] = [];

    //filters
    filter_supervisionStatus: SupervisionStatusEnum = SupervisionStatusEnum.OPEN;


    configEndEvent: EventEmitter<any> = new EventEmitter();
    configStatusEvent: EventEmitter<any> = new EventEmitter();
    /**
     * deprecated, use configErrorByTypeEvent
     */
    configErrorEvent: EventEmitter<any> = new EventEmitter();
    /**
     * Event for errors. por ahora errType es un string con la operacion que se realiza
     */
    configErrorByTypeEvent: EventEmitter<{ errType: any, err: any }> = new EventEmitter();

    public notifier: NotifierService;
    public notifyid: string = "LOADER_BASE";

    constructor(public baseService: SolarService
    ) {
        //super();
        const injector = AppInjector.getInjector();
        if (injector) {
            this.notifier = injector.get(NotifierService);
        }
    }
    /**
     * Response object
     */
    public initialDataLoaded = { haserror: "", errorType: "", "supervision": false, "site_panelstype": false, "site_panels": false, "supervision_issues": false };

    configureDataTree() { }
    step: number = 0;
    executeFlow() {

        //todo:la unica forma de cambiar el proceso secuencialmente sin tener que rehacer todo el codigo
        //este metodo debe llamarse por los handleresult de la secuencia, ahora mismo solo es necesario en supervision model
        //las clases que heredan podrán cambiar la carga o quitar/poner pasos
        //executeflow se llama en el paso 2
        switch (this.step) {
            /* case 0:
                            this.getSupervisionModel(this.id_supervision);
                            break; */
            //1 paneltypes
            //2 panels 
        }
    }

    handleErrorByType(type: string, err: any) {
        this.configErrorByTypeEvent.emit({ errType: type, err: err });
        this.configErrorEvent.emit(err);//todo:eliminar este metodo cuando se pueda
    }

    getSupervisionModel(id): void {
        this.baseService.supervisionGetById(id)
            .subscribe(
                resmodel => this.getSupervisionModelhandleresult(resmodel)
                , err =>
                    this.handleErrorByType(SolarErr.ERR_LOAD_SUPERVISION, err)
            );

    }

    getSupervisionModelhandleresult(resmodel: Supervision) {


        let siteId=resmodel.site.id;
        let site = this.baseService.siteById(siteId);//todo: site must be retrieved before use this component. We assume that the site was loaded when the app starts
        if (site != null) {
            resmodel.site=site;
        }
        else {
            //load full site and recall
            this.baseService.siteGetById(siteId)
                .subscribe(siteModel => {
                    resmodel.site = siteModel,
                    this.getSupervisionModelhandleresult(resmodel)
                }
                    , err => this.handleErrorByType(SolarErr.ERR_LOAD_SUPERVISION, err)
                );
            return;
        }
        this.supervision = resmodel;
        this.site = resmodel.site;
        //this.notifier.notify(NotificationType.Info, "Supervision loaded, loading panels.");
        this.initialDataLoaded.supervision = true;
        if (this.supervision.info.status==SupervisionStatusEnum.VALIDATED){
            //get data only of issues validated
            this.filter_supervisionStatus=SupervisionStatusEnum.VALIDATED;
          }
        this.executeFlow();
    }


    getSitePanelsConfiguration(id_site): void {
        //en lugar de usar el flow de RX usamos que cada metodo llame al siguiente
        this.siteGetPanelsType(id_site);
    }

    siteGetPanelsType(id_site: string) {
        let res = this.baseService.siteGetPanelsTypes(id_site)
        res.then(
            resmodel => {
                this.configStatusEvent.emit(this.getStatusMessage(AlertType.Info, "Loading supervision: Panel types loaded"))
                    , console.log("getSitePanelsType count %s", resmodel.length)
                    , this.site_panels_type = resmodel
                    , this.initialDataLoaded.site_panelstype = true
                    , this.executeFlow()
            });

        res.catch(err => this.handleErrorByType(SolarErr.ERR_LOAD_PANELSTYPE, err));

    }

    async siteGetPanels(id_site: string) {
        let exist = true;
        let limit = 5000;
        let offset = 0;
        let panels: any[] = [];
        let totaltime = 0;
        while (exist) {
            let startTime = new Date();
            let resmodel = await this.baseService.siteGetPanelsByLoop(id_site, limit, offset);
            offset += limit;
            let timeDiff = TimePerf.timeElapsed(startTime);
            totaltime += timeDiff;
            this.configStatusEvent.emit(this.getStatusMessage(AlertType.Info, "Loading supervision site panels. Loaded until now:" + offset + " in " + totaltime.toFixed(2) + " seconds"));
            //console.log("----------siteGetPanels", resmodel);
            console.log("getSitePanels count %s", offset);
            this.site_panels = this.site_panels.concat(resmodel);

            if (resmodel.length == 0 || resmodel.length < limit) {
                exist = false;
                break;
            }


            /*             res.then(
                            resmodel => {
                                this.configStatusEvent.emit(this.getStatusMessage(AlertType.Info, "Loading supervision: Site Panels loaded"));
                                console.log("----------siteGetPanels", resmodel);
                                console.log("getSitePanels count %s", resmodel.length);
                                this.site_panels = resmodel;
                                this.initialDataLoaded.site_panels = true;
                                exist=false;
                                this.executeFlow();
                            }
                        ); */
            //res.catch(err => this.handleErrorByType(ExLoaderBase.ERR_LOAD_PANELS, err));

        }

        this.initialDataLoaded.site_panels = true;
        this.executeFlow();

    }

    async supervisionGetPanels(id_supervision: string) {
        this.configStatusEvent.emit(this.getStatusMessage(AlertType.Info, "Loading supervision panels, please wait"));
        let res = this.baseService.supervisionGetPanelsWithError(id_supervision);
        res.then(
            resmodel => {
                this.configStatusEvent.emit(this.getStatusMessage(AlertType.Info, "Loading supervision panels: loaded"));
                //console.log("------------supervisionGetPanels", resmodel);
                //console.log("supervisionGetPanels count %s", resmodel.length);
                this.site_panels = this.configurePanelName(resmodel);
                this.initialDataLoaded.site_panels = true;
                this.executeFlow();
            }
        );
        res.catch(err => this.handleErrorByType(SolarErr.ERR_LOAD_PANELS, err));
    }

    private configurePanelName(panels: Panel[]) {
        
        let panelPatternList = Site.getPanelPattern(this.site, "list");
          
        for (let x = 0; x < panels.length; x++) {
            let panel = panels[x];
            panel.name = Panel.uiLocatorByPanel(panel, panelPatternList);
        }
        return panels;
    }

    /**
    * Return the list of issues for supervision
    * @param supervision_id 
    */
    getIssueList(supervision_id): void {
        let filter: string = "";
        if (this.filter_supervisionStatus == SupervisionStatusEnum.VALIDATED) {
            //filter only validated
            filter = "filter={\"filter\":\" (supervision_issue.info ->> 'status'::text) = '2'::text  AND (supervision_issue.type <> ALL (ARRAY['NDM'::text, 'CBOX'::text, 'UNK'::text])) \"}";
        }
        this.configStatusEvent.emit(this.getStatusMessage(AlertType.Info, "Loading supervision: Loading  issues"))
        this.baseService.supervisionGetIssues(supervision_id, filter)
            .subscribe(
                res_list => {
                    res_list = this.filterIssueWithoutPanel(res_list)
                        /* ,console.log('getIssueListHandleresult count %s',res_list.length, res_list) */
                        , this.configStatusEvent.emit(this.getStatusMessage(AlertType.Info, "Loading supervision: " + res_list.length + " Issues loaded"))
                        , this.getIssueListHandleresult(res_list)

                }
                , err => this.handleErrorByType(SolarErr.ERR_LOAD_ISSUES, err)
            );
    }

    private filterIssueWithoutPanel(res_list: SupervisionError[]) {
        let filtered = res_list;
        return filtered;
    }

    private getIssueListHandleresult(newlist: any[]) {
        //newlist = SortHelper.sortMultiple(newlist, ['info.panel.locator.L1', 'info.panel.locator.L2', 'info.panel.locator.L3']);
        //this.configStatusEvent.emit(this.getStatusMessage(AlertType.Info, "Loading supervision: "+newlist.length+" Issues loaded" ));
        this.issues = newlist;
        this.initialDataLoaded.supervision_issues = true;
        this.executeFlow();
    }

    protected getStatusMessage(type: AlertType, message: string) {
        let res = { type: type, message: message };
        return res;
    }
}